import { FC } from "react";
import usac1x from "./usac@1x.png";
import usac2x from "./usac@2x.png";

interface GoverningBodyIconProps {
  governingBody: string;
}

const ICON_MAP: Record<string, { src1x: string; src2x: string; alt: string }> =
  {
    "USA Cycling": { src1x: usac1x, src2x: usac2x, alt: "USA Cycling" },
  };

/**
 * Displays a governing body icon. Renders a retina-ready image for
 * known bodies (USA Cycling, RUSA) or a text pill for unknown ones.
 */
export const GoverningBodyIcon: FC<GoverningBodyIconProps> = ({
  governingBody,
}) => {
  const icon = ICON_MAP[governingBody];

  if (icon) {
    return (
      <img
        src={icon.src2x}
        srcSet={`${icon.src1x} 1x, ${icon.src2x} 2x`}
        alt={icon.alt}
        className="h-full w-auto object-contain h-2"
      />
    );
  }

  return (
    <span className="px-2.5 py-1 bg-blue-500 text-white text-xs font-medium rounded">
      {governingBody.toUpperCase()}
    </span>
  );
};
